import { createBroadcastEvent } from '@h5s/util-broadcast';

/**
 * Evento inviato da una tab per chiedere alle altre se sono attive.
 * Viene usato per determinare se l'intera applicazione è inattiva
 * prima di forzare un aggiornamento quando la deadline è raggiunta.
 */
export const TAB_ACTIVE_REQUEST_EVENT = createBroadcastEvent('TAB_ACTIVE_REQUEST_EVENT');
